import { normalizePath } from '../../../../utils/path';
import { getFileTemplate, validateFilePath } from '../../../../utils/fileTemplates';

export async function execute(args, context) {
  const { saveFile, fileList, setFileList, onFileChanged } = context;
  const { path, content = '' } = args;

  const normalizedPath = normalizePath(path);

  // Validate path
  const validation = validateFilePath(normalizedPath);
  if (!validation.valid) {
    return {
      success: false,
      error: validation.error
    };
  }

  // Check if file already exists
  if (fileList.find(f => f.Key === normalizedPath)) {
    return {
      success: false,
      error: `File already exists: ${normalizedPath}. Use write_file or edit_file to modify.`
    };
  }

  // Get content (use template if empty)
  const fileContent = getFileTemplate(normalizedPath, content);

  try {
    // Save file and original copy
    await saveFile(normalizedPath, fileContent);
    await saveFile(`${normalizedPath}-original`, fileContent);

    // Track as changed
    const changedFiles = JSON.parse(sessionStorage.getItem('changedFiles')) || [];
    if (!changedFiles.includes(normalizedPath)) {
      changedFiles.push(normalizedPath);
      sessionStorage.setItem('changedFiles', JSON.stringify(changedFiles));
    }

    // Update file list
    const newFile = { Key: normalizedPath, Size: fileContent.length };
    setFileList(prev => [...prev, newFile]);

    // Notify
    if (onFileChanged) {
      await onFileChanged(normalizedPath, fileContent);
    }

    return {
      success: true,
      path: normalizedPath,
      size: fileContent.length,
      lines: fileContent.split('\n').length,
      message: `Created ${normalizedPath}`
    };
  } catch (err) {
    return {
      success: false,
      error: `Failed to create file: ${err.message}`
    };
  }
}
